import { MoreNavigationActionExtension } from "@geolib/geoappbase-client";
import { inject, Injectable } from "@angular/core";
import { StateService } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })

export default class EventSubscriptionExtension extends MoreNavigationActionExtension {
    private readonly stateService = inject(StateService);

    public callback(): void {
        this.stateService.go("app.profileEvents");
    }

    public isEnabled(): boolean {
        return true;
    }

    public get title(): string {
        return "HEADER.NOTIFICATIONS";
    }
}

